import * as React from "react";
import AppHeader from "../AppHeader/AppHeader";
import Box from "@mui/material/Box";
import Footer from "../Footer/Footer";
import { BranchValidator } from "../BranchValidator/BranchValidator";
import { UserBranchEnforcer } from "../UserBranchEnforcer/UserBranchEnforcer";
import { ChatbotPopup } from "../ChatbotPopup/ChatbotPopup";
import { SystemAnnouncementBanner } from "../SystemAnnouncementBanner/SystemAnnouncementBanner";
import { useQuery } from "react-query";
import { ChatbotService } from "gen/clients/llts";
import { useUserSession } from "hooks/useUserSession";
import { useUserAccount } from "hooks/useUserAccount";
import { useDocumentTitle } from "hooks/useDocumentTitle";
import { useTranslation } from "react-i18next";

interface Props {
  children: React.ReactNode;
  hideSignInButtonInHeader?: boolean;
  title?: string;
}

const PageLayout: React.FC<Props> = ({ children, hideSignInButtonInHeader, title }) => {
  const { username } = useUserSession();
  const { data: chatbotSettings } = useQuery("getSystemSettings", {
    queryFn: ChatbotService.getChatbotSettings
  });
  const { data: userAccount, isLoading: isUserAccountLoading } = useUserAccount();
  const { t } = useTranslation();
  useDocumentTitle(title);
  // The client setting takes precedence; when it is not set, the system setting is used.
  const isChatbotHelpCenterEnabled =
    !isUserAccountLoading &&
    (userAccount?.clientConfig?.isChatbotHelpCenterEnabled ?? chatbotSettings?.isChatbotHelpCenterEnabled ?? false);
  return (
    <UserBranchEnforcer>
      <Box
        component="a"
        href="#main-content"
        sx={{
          position: "absolute",
          left: "-9999px",
          top: 0,
          zIndex: 10000,
          padding: "8px 16px",
          backgroundColor: "#ffffff",
          color: "#000000",
          textDecoration: "underline",
          "&:focus": {
            left: "8px",
            top: "8px",
            outline: "2px solid #1976d2"
          }
        }}
      >
        {t("appHeader.skipToMainContent")}
      </Box>
      <BranchValidator />
      <AppHeader hideSignInButton={hideSignInButtonInHeader} />
      <SystemAnnouncementBanner />
      <Box component="main" id="main-content" tabIndex={-1} sx={{ flex: 1 }}>
        {children}
      </Box>
      <Footer />
      {isChatbotHelpCenterEnabled && <ChatbotPopup username={username} />}
    </UserBranchEnforcer>
  );
};

export { PageLayout };
